import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetAccountInfoQuery } from '../../../../api/account';
import { useGetAgentInfoMutation } from '../../../../api/agent';
import { useAppDispatch } from '../../../../store';
import { setLoadingModal } from '../../../../store/slice/modal';

const Contents = () => {

  const dispatch = useAppDispatch();

  const { id } = useParams();
  const { data, isLoading, refetch } = useGetAccountInfoQuery(id);
  //get agent information with useGetAgentInfoMutation
  const [agentApi] = useGetAgentInfoMutation();
  const attorneyData = data?.data;
  const [agentInfo, setAgentInfo] = useState({});

  //get html element by id = genos
  const genos = document.getElementById('genos');
  //hide genos
  genos.style.display = 'none';
  //get html element by id =chatbot-toggler
  const chatbotToggler = document.getElementById('chatbot-toggler');
  //hide chatbot-toggler
  chatbotToggler.style.display = 'none';

  useEffect(() => {
    //Loading modal    
    if (isLoading) {
      dispatch(
        setLoadingModal({
          modalState: true,
        })
      );
    } else {
      dispatch(
        setLoadingModal({
          modalState: false,
        })
      );
    }
  } , [isLoading]);

  useEffect(() => {
      //get agent information
    if(attorneyData?.agentNo){
      agentApi(`agentNo/${attorneyData?.agentNo}`)
        .unwrap()
        .then((res) => {
          if(res?.data?.length > 0){
            setAgentInfo(res.data[0]);
          }
        });
      }
  } , [attorneyData]);
  return (
    <div style={{ padding: '20px', whiteSpace: "pre-wrap"}}>
      <h1>{agentInfo.name} Attorney</h1>
      <TextField
        label="Office Name"
        value={agentInfo.officeName || 'Office information is not available.'}
        fullWidth
        margin='normal'
        disabled
        sx={{
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: 'black',
          },
        }}
      />
      <TextField
        label="Main Area"
        value={agentInfo.mainArea || 'Main area information is not available.'}
        fullWidth
        margin='normal'
        disabled
        sx={{
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: 'black',
          },
        }}
      />
      {/* 부분야 1, 2 , 3 을 한 라인에 보여주자 */}
      <TextField
        label="Sub-area 1"
        value={agentInfo.subArea1 || 'Sub-area 1 information is not available.'}
        fullWidth
        margin='normal'
        disabled
        sx={{
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: 'black',
          },
        }}
      />
      <TextField
        label="Sub-area 2"
        value={agentInfo.subArea2 || 'Sub-area 2 information is not available.'}
        fullWidth
        margin='normal'
        disabled
        sx={{
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: 'black',
          },
        }}
      />
      <TextField
        label="Sub-area 3"
        value={agentInfo.subArea3 || 'Sub-area 3 information is not available.'}
        fullWidth
        margin='normal'
        disabled
        sx={{
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: 'black',
          },
        }}
      />
      <TextField
        label="Career"
        value={agentInfo?.career || 'Career information is not available.'}
        fullWidth
        multiline
        margin='normal'
        disabled
        sx={{
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: 'black',
          },
        }}
      />
      <TextField
        label="Education"
        value={agentInfo.education || 'Education information is not available.'}
        fullWidth
        multiline
        margin='normal'
        disabled
        sx={{
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: 'black',
          },
        }}
      />
      <TextField
        label="Qualification"
        value={agentInfo.qualification || 'Qualification information is not available.'}
        fullWidth
        margin='normal'
        disabled
        sx={{
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: 'black',
          },
        }}
      />
    </div>
  );
};

export default Contents;